import { expenseTypes } from "../data/expense-types";
import { Expense } from "../models/expenses";

export function getExpenseTypeLabel(type: Expense["type"]): string {
  const index = expenseTypes.findIndex(
    (expenseType) => expenseType.value === type
  );
  return expenseTypes[index].label;
}
